export type LogisticsOrderStatus =
  | 'pending'
  | 'scheduled'
  | 'in_transit'
  | 'delivered'
  | 'returned'
  | 'cancelled';

export type LogisticsOrderType = 'delivery' | 'pickup' | 'transfer';

export type LogisticsOrder = {
  id: string;
  companyId: string;
  reservationId: string | null;
  type: LogisticsOrderType;
  status: LogisticsOrderStatus;
  scheduledDate: string;
  providerId: string | null;
  address: string;
  contactName: string;
  contactPhone: string;
  notes: string;
  inventoryItemIds: string[];
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
};

export type LogisticsOrderInput = {
  reservationId: string | null;
  type: LogisticsOrderType;
  status: LogisticsOrderStatus;
  scheduledDate: string;
  providerId: string | null;
  address: string;
  contactName: string;
  contactPhone: string;
  notes: string;
  inventoryItemIds: string[];
};

export const LOGISTICS_ORDER_STATUS_LABELS: Record<LogisticsOrderStatus, string> =
  {
    pending: 'Pendiente',
    scheduled: 'Programada',
    in_transit: 'En tránsito',
    delivered: 'Entregada',
    returned: 'Devuelta',
    cancelled: 'Cancelada',
  };

export const LOGISTICS_ORDER_TYPE_LABELS: Record<LogisticsOrderType, string> = {
  delivery: 'Entrega',
  pickup: 'Retiro',
  transfer: 'Transferencia',
};
